/** Matches --primary in index.css and the lucide MapPin palette icon. */
export const MAP_PIN_COLOR = '#6200ee';

export const MAP_PIN_PATH =
  'M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0';

export function buildMapPinSvgDataUrl({
  color = MAP_PIN_COLOR,
  size = 36,
  strokeWidth = 2,
} = {}) {
  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none"`,
    ` stroke="${color}" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round">`,
    `<path d="${MAP_PIN_PATH}"/>`,
    '<circle cx="12" cy="10" r="3"/>',
    '</svg>',
  ].join('');

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/** Google Maps Marker icon config using the same lucide-style pin. */
export function createGoogleMapPinIcon({
  color = MAP_PIN_COLOR,
  size = 36,
} = {}) {
  return {
    url: buildMapPinSvgDataUrl({ color, size }),
    scaledSize: new google.maps.Size(size, size),
    anchor: new google.maps.Point(size / 2, size * 0.94),
  };
}
